// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import axios from 'axios'
import VueAxios from 'vue-axios'
import store from './store'
import BaiduMap from 'vue-baidu-map'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)
Vue.config.productionTip = false
Vue.use(VueAxios,axios);
Vue.use(BaiduMap, {
  ak: 'z5IAghTlhij7Bz088j2glMxhmEtNme2v'
})
/* eslint-disable no-new */
router.afterEach((to,from,next) => {
  window.scrollTo(0,0);
})
import isJpg from "@/components/common/isJpg"
Vue.component('isJpg',isJpg)
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js